import * as React from "react";
import {
  Popover,
  Table,
  OverlayTrigger,
  OverlayTriggerProps,
  Button,
} from "react-bootstrap";
import I18n from "lib/I18n";
import style from "./style.module.css";
import { PopoverProps } from "react-bootstrap";

function createPopover(
  prefixElement?: JSX.Element,
  suffixElement?: JSX.Element,
) {
  return (props: PopoverProps) => (
    <Popover id="popoverTypeHelp" className={style.popover} {...props}>
      <Popover.Body>
        {prefixElement}
        <Table>
          <thead>
            <tr>
              <th>{I18n.t("role_popup.label.role")}</th>
              <th>{I18n.t("role_popup.label.description")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{I18n.t("roles.owner")}</td>
              <td>{I18n.t("role_popup.message.desc1")}</td>
            </tr>
            <tr>
              <td>{I18n.t("roles.developer")}</td>
              <td>
                {I18n.t("role_popup.message.desc2")}
                <strong className="text-danger">
                  {I18n.t("role_popup.message.desc3")}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{I18n.t("roles.business")}</td>
              <td>{I18n.t("role_popup.message.desc4")}</td>
            </tr>
            <tr>
              <td>{I18n.t("roles.collaborator")}</td>
              <td>
                {I18n.t("role_popup.message.desc5", {
                  developer: I18n.t("roles.developer"),
                })}
                <ul>
                  <li>{I18n.t("role_popup.message.desc6")}</li>
                  <li>{I18n.t("role_popup.message.desc7")}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{I18n.t("roles.observer")}</td>
              <td>{I18n.t("role_popup.message.desc8")}</td>
            </tr>
          </tbody>
        </Table>
        {suffixElement}
      </Popover.Body>
    </Popover>
  );
}

interface RolePopupProps {
  placement: OverlayTriggerProps["placement"];
  prefixElement?: JSX.Element;
  suffixElement?: JSX.Element;
}

export function RolePopup(props: RolePopupProps) {
  const { placement, prefixElement, suffixElement } = props;

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement={placement}
      overlay={createPopover(prefixElement, suffixElement)}
    >
      <Button variant="info" style={{ borderRadius: 30, padding: "0px 8px" }}>
        ?
      </Button>
    </OverlayTrigger>
  );
}
